module.exports = __webpack_public_path__ + "img/slim.6390fde9.jpg";